import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { ActionTypeEnum, labelsType, useCashPayModel } from "../cashPayModel";
import { WaitCashPay } from './waitPay'
import { AlreadyCashPay } from './alreadyPay'
import { orgService } from "../../../base/org/orgService";
import { beService } from "../../../base/be/beService";
import { dictService } from "../../../base/dict/dictService";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { useGlobalModel } from "@/model/globalModel";
import useNavModel, { RouterParamType } from "@/model/navModel";

export const CashPay = () => {
	const {
		actionType,
		setActionType,
		setOrgDs,
		setBeDs,
		setPayMethodDs,
		setPayMethodLabels,
		setUserTypeLabels,
	} = useCashPayModel();
	const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
	const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

	const { resourceAuth, getSelectedDict } = useGlobalModel();

	useEffect(() => {
		let obj: labelsType = {}, obj1: labelsType = {};
		orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
		beService.beDs({}).then(ds => setBeDs(ds))
		dictService.accountTreeOne(DictCodeEnmu.PAY_METHOD).then(ds => { setPayMethodDs(ds) })

		getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
			obj[item.value] = item.label
		})
		getSelectedDict(DictCodeEnmu.USER_TYPE).forEach(item => {
			obj1[item.value] = item.label
		})
		setPayMethodLabels(obj);
		setUserTypeLabels(obj1);
		if (detailsInfo && detailsInfo?.id == '待付') {
			setActionType(ActionTypeEnum.WAITCOLLECT)
		} else {
			setActionType(() => {
				//所有tab权限
				let authArr = [ResourceAuthEnum.CASH_PAY_DONE, ResourceAuthEnum.CASH_PAY_WILL,];
				//过滤出来所有分配的权限；
				let findAuth = resourceAuth.filter(item => authArr.indexOf(item as ResourceAuthEnum) >= 0);
				if (!findAuth.length) return ActionTypeEnum.NULL;
				switch (findAuth.length > 1 ? findAuth[1] : findAuth[0]) {
					case ResourceAuthEnum.CASH_PAY_DONE:
						return ActionTypeEnum.ALREADYCOLLECT;
					case ResourceAuthEnum.CASH_PAY_WILL:
						return ActionTypeEnum.WAITCOLLECT;
					default:
						return ActionTypeEnum.NULL;
				}
			})
		}
	}, []);


	const onWaitCollectList = () => {
		setActionType(ActionTypeEnum.WAITCOLLECT)
	}
	const onAlreadyCollectList = () => {
		setActionType(ActionTypeEnum.ALREADYCOLLECT)
	}
	const classname = (type: ActionTypeEnum) => {
		return 'tab-item ' + (actionType === type ? 'tab-active' : '')
	}
	const action = (
		<>
			<YhAuth resCode={ResourceAuthEnum.CASH_PAY_WILL}>
				<Button
					className={classname(ActionTypeEnum.WAITCOLLECT)}
					type="link"
					shape="round"
					onClick={onWaitCollectList}
				> 待付 </Button>
			</YhAuth>
			<YhAuth resCode={ResourceAuthEnum.CASH_PAY_DONE}>
				<Button
					className={classname(ActionTypeEnum.ALREADYCOLLECT)}
					type="link"
					shape="round"
					onClick={onAlreadyCollectList}
				> 已付 </Button>
			</YhAuth>
		</>
	);
	/**
	 * 内容区判断
	 */
	const DetailDataBox = () => {
		switch (actionType) {
			case ActionTypeEnum.WAITCOLLECT:
				return <WaitCashPay />;
			case ActionTypeEnum.ALREADYCOLLECT:
				return <AlreadyCashPay />;
			default:
				return <></>
		}
	}

	return (
		<>
			<YhBox
				title="现金付款"
				action={action}
			/>
			{actionType === ActionTypeEnum.WAITCOLLECT ? <WaitCashPay /> : actionType === ActionTypeEnum.ALREADYCOLLECT ? <AlreadyCashPay /> : null}
			{/* <DetailDataBox /> */}
		</>
	)
}

